/*
  <becay-loop-video> — vídeo de fondo en bucle que no frena la web.
  ------------------------------------------------------------------
  Lo usan el hero de la portada (sections/slideshow.liquid) y los vídeos
  intercalados en la parrilla de colección (snippets/becay-video-tile.liquid).

  Por qué así (no deshacer sin medir):
  - El <video> llega al HTML SIN src y con preload="none": el navegador no
    descarga ni un byte de vídeo mientras pinta la página. El LCP es siempre
    la imagen que hay debajo (póster), nunca el vídeo.
  - Hero: lo arranca un script en línea de snippets/becay-loop-video.liquid
    en cuanto el parser llega al vídeo, sin esperar a este fichero ni al
    resto de la portada (Luis, 2026-10-15: "siempre hay un frame congelado").
    Antes esperaba al load de la página entera más un hueco libre del hilo,
    y luego al DOMContentLoaded: los dos son segundos de póster quieto en una
    portada con cientos de tarjetas. El póster va antes en el HTML, así que el
    vídeo no le quita el turno; si algún día el LCP de la portada empeora,
    este es el primer sitio que mirar.
    Parrilla: cuando la tarjeta está a una pantalla de entrar en vista (antes
    300 px, que no daban tiempo a que llegase el primer trozo del vídeo).
  - Un solo <video> por bloque. El vídeo de móvil y el de escritorio NO
    conviven en el DOM (el de Prestige pintaba los dos y escondía uno con
    CSS): aquí el JS elige uno por ancho de pantalla.
  - De las versiones MP4 que genera Shopify (480p/720p/1080p) se pide la más
    pequeña que cubre el hueco a la densidad real de la pantalla (con tope
    x2): un móvil se baja la de 720p, no la de 1080p. HLS (.m3u8) no se usa:
    en bucle corto da saltos al reiniciar en Safari y no ahorra nada.
  - Sin controles y sin pausa manual (decisión de marca). Solo se pausa
    cuando nadie lo ve: fuera de pantalla o con la pestaña oculta. Eso no lo
    nota el visitante y ahorra batería y CPU.
  - No se reproduce (se queda la imagen) con "reducir movimiento" activado,
    con ahorro de datos o en 2G, y si el navegador rechaza el autoplay (modo
    bajo consumo del iPhone). En todos esos casos se ve el póster, nunca un
    hueco negro.
  - El vídeo aparece con un fundido solo cuando ya está reproduciendo
    (evento playing), así nunca se ve un fotograma negro ni un salto.
*/
(function () {
  if (window.customElements && customElements.get('becay-loop-video')) return;

  var shouldSkip = function () {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return true;
    } catch (e) {}
    return false;
  };

  /*
    TINTA DEL MENU SOBRE EL HERO (Luis, 2026-10-14: "opcion 2").
    El header pintaba el island en blanco con mix-blend-mode: difference. Sobre un video eso invierte cada plano: sale
    marron sobre el mar, pizarra sobre una pared clara, y cambia de color con cada fotograma. Aqui se mira el trozo
    de imagen que hay DETRAS del menu (48x8 px, cada 400 ms, solo arriba del todo y con la pestana visible) y se
    elige tinta blanca pura o negra pura. Las clases van en <html> y el CSS vive en snippets/becay-header-glass.liquid
    (bloque 5l):
      .bcy-adapt     = hay hero con video arriba (la pone el script en linea del snippet antes de pintar). Apaga la
                       mezcla difference; mientras no hay muestra, tinta blanca con su sombra suave (5c).
      .bcy-ink-dark  = lo de detras es claro: tinta negra.
    Sesgado a BLANCO (Luis: "mas light"): solo pasa a negro con un fondo de verdad claro (luminancia > 0,72; una
    pared encalada da ~0,85, el mar ~0,6) y vuelve a blanco por debajo de 0,60. Esa histeresis evita que un plano a
    medio tono haga parpadear el menu. La primera decision entra sin transicion; las siguientes con un fundido de 0,45 s.
    Si el navegador no deja leer los pixeles (video de otro dominio sin CORS) se quita .bcy-adapt y vuelve la mezcla
    de siempre: el peor caso es el comportamiento anterior, nunca un menu ilegible.
  */
  var Ink = {
    started: false,
    start: function (host) {
      var root = document.documentElement;
      if (this.started || !root.classList.contains('bcy-adapt')) return;
      this.started = true;
      this.host = host;
      this.img = host.parentElement ? host.parentElement.querySelector('picture img') : null;
      this.canvas = document.createElement('canvas');
      this.canvas.width = 48;
      this.canvas.height = 8;
      try { this.ctx = this.canvas.getContext('2d', { willReadFrequently: true }); } catch (e) { this.ctx = null; }
      if (!this.ctx) return this.off();
      this.dark = null;
      var self = this;
      if (this.img && !this.img.complete) this.img.addEventListener('load', function () { self.sample(); }, { once: true });
      host.video.addEventListener('playing', function () { self.sample(); });
      var tick = function () { self.sample(); self.timer = setTimeout(tick, 400); };
      tick();
    },
    off: function () {
      clearTimeout(this.timer);
      document.documentElement.classList.remove('bcy-adapt', 'bcy-ink-dark');
    },
    source: function () {
      var v = this.host.video;
      if (this.host.classList.contains('is-playing') && v.readyState >= 2 && v.videoWidth) return v;
      var i = this.img;
      if (i && i.complete && i.naturalWidth) return i;
      return null;
    },
    sample: function () {
      var root = document.documentElement;
      if (document.hidden || !root.classList.contains('bcy-adapt') || !root.classList.contains('bcy-top')) return;
      var el = this.source();
      var nav = document.querySelector('.d-header-wrapper .d-nav');
      if (!el || !nav) return;
      var r = el.getBoundingClientRect();
      var n = nav.getBoundingClientRect();
      var iw = el.videoWidth || el.naturalWidth;
      var ih = el.videoHeight || el.naturalHeight;
      if (!r.width || !r.height || !n.width || !n.height) return;
      // object-fit: cover -> que trozo del fotograma queda detras del menu.
      var s = Math.max(r.width / iw, r.height / ih);
      var pos = (getComputedStyle(el).objectPosition || '50% 50%').split(' ');
      var px = parseFloat(pos[0]) / 100;
      var py = parseFloat(pos[1] || pos[0]) / 100;
      if (isNaN(px)) px = 0.5;
      if (isNaN(py)) py = 0.5;
      var ox = r.left + (r.width - iw * s) * px;
      var oy = r.top + (r.height - ih * s) * py;
      var sx = Math.max(0, (n.left - ox) / s);
      var sy = Math.max(0, (n.top - oy) / s);
      var sw = Math.min(iw - sx, n.width / s);
      var sh = Math.min(ih - sy, n.height / s);
      if (sw <= 1 || sh <= 1) return;
      var d;
      try {
        this.ctx.drawImage(el, sx, sy, sw, sh, 0, 0, 48, 8);
        d = this.ctx.getImageData(0, 0, 48, 8).data;
      } catch (e) {
        if (el === this.img) { this.img = null; return; }   // poster de otro dominio: se espera al video
        return this.off();
      }
      // Luminancia de cada punto; cuenta la media y el percentil 80 (lo claro es lo que se come a la tinta blanca).
      var l = [];
      for (var k = 0; k < d.length; k += 4) l.push((0.2126 * d[k] + 0.7152 * d[k + 1] + 0.0722 * d[k + 2]) / 255);
      l.sort(function (a, b) { return a - b; });
      var mean = 0;
      for (var j = 0; j < l.length; j++) mean += l[j];
      mean /= l.length;
      var L = (mean + l[Math.floor(l.length * 0.8)]) / 2;
      var dark = this.dark === null ? L > 0.68 : (this.dark ? L > 0.6 : L > 0.72);
      this.lum = L;
      if (dark === this.dark) return;
      var first = this.dark === null;
      this.dark = dark;
      if (first) root.classList.add('bcy-ink-now');
      root.classList.toggle('bcy-ink-dark', dark);
      if (first) {
        root.getBoundingClientRect();
        requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('bcy-ink-now'); }); });
      }
    }
  };
  window.BecayHeaderInk = Ink;

  // Sin sonido, siempre: atributo muted en el HTML, propiedades al conectar y, si algo (una extension, el navegador)
  // le devuelve el volumen, se vuelve a silenciar en el acto.
  var silence = function (v) {
    v.muted = true;
    v.defaultMuted = true;
    v.volume = 0;
    v.setAttribute('muted', '');
  };

  /*
    AUTOPLAY BLOQUEADO (2026-10-15). Con el modo de bajo consumo del iPhone (la bateria en amarillo), Safari rechaza
    el play() de cualquier video aunque vaya sin sonido, y el visitante se queda con el poster aunque tenga buena
    conexion. Lo unico que lo desbloquea es un gesto suyo: se apuntan los videos rechazados y se vuelven a lanzar en el
    primer toque, clic o tecla, que en una web de moda es casi inmediato (deslizar no cuenta, tocar si). Las escuchas
    son pasivas, se ponen solo si algun video fue rechazado y se quitan en cuanto no queda ninguno pendiente.
  */
  var blocked = new Set();
  var armed = false;
  var onGesture = function () {
    blocked.forEach(function (el) {
      if (!el.isConnected) { blocked.delete(el); return; }
      if (!el.visible || !el.src) return;
      silence(el.video);
      var p = el.video.play();
      if (p && p.then) p.then(function () { blocked.delete(el); if (!blocked.size) disarm(); }, function () {});
    });
  };
  var disarm = function () {
    if (!armed) return;
    armed = false;
    ['touchend', 'click', 'keydown'].forEach(function (t) { document.removeEventListener(t, onGesture, true); });
  };
  var armGesture = function () {
    if (armed) return;
    armed = true;
    ['touchend', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, onGesture, { capture: true, passive: true }); });
  };

  class BecayLoopVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this._ready) return;
      this._ready = true;
      silence(this.video);
      this.video.addEventListener('volumechange', () => {
        if (!this.video.muted || this.video.volume > 0) silence(this.video);
      });
      if ((this.getAttribute('data-mode') || 'tile') === 'hero') Ink.start(this);
      if (shouldSkip()) return;

      try { this.sources = JSON.parse(this.getAttribute('data-sources') || '{}'); } catch (e) { return; }
      var bp = parseInt(this.getAttribute('data-breakpoint') || '700', 10);
      this.mq = window.matchMedia('(max-width: ' + (bp - 1) + 'px)');
      this.mode = this.getAttribute('data-mode') || 'tile';
      this.visible = false;

      var v = this.video;
      v.playsInline = true;
      // Hero: el JS lee sus fotogramas para elegir la tinta del menu. El CDN de Shopify responde con
      // access-control-allow-origin: *, asi que con crossOrigin el canvas no queda contaminado ni en otro dominio.
      if (this.mode === 'hero') v.crossOrigin = 'anonymous';
      v.addEventListener('playing', () => { this.classList.add('is-playing'); blocked.delete(this); });
      // Si el arranque temprano ya esta reproduciendo cuando llega este JS, el evento playing ya paso.
      if (!v.paused && v.readyState >= 3) this.classList.add('is-playing');
      v.addEventListener('error', () => this.fallback());

      this._onVisibility = () => {
        if (document.hidden) v.pause();
        else if (this.visible) this.play();
      };
      document.addEventListener('visibilitychange', this._onVisibility);

      this._onBreakpoint = () => {
        if (!this.src) return;
        var next = this.pick();
        if (next && next !== this.src) {
          this.classList.remove('is-playing');
          this.src = next;
          v.src = next;
          if (this.visible) this.play();
        }
      };
      if (this.mq.addEventListener) this.mq.addEventListener('change', this._onBreakpoint);

      var start = () => {
        if (!this.isConnected) return;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.visible = entry.isIntersecting;
            if (this.visible) {
              this.load();
              this.play();
            } else {
              v.pause();
            }
          });
        }, { rootMargin: this.mode === 'hero' ? '0px' : '100% 0px', threshold: 0.01 });
        this.io.observe(this);
      };

      if (this.mode === 'hero') {
        if (document.readyState !== 'loading') start();
        else document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
      if (this.mq && this.mq.removeEventListener && this._onBreakpoint) this.mq.removeEventListener('change', this._onBreakpoint);
      this._ready = false;
    }

    list() {
      var s = this.sources || {};
      var list = this.mq.matches && s.m && s.m.length ? s.m : s.d;
      if (!list || !list.length) return [];
      return list.slice().sort(function (a, b) { return a[0] - b[0]; });
    }

    pick() {
      var list = this.list();
      if (!list.length) return null;
      var biggest = list[list.length - 1];
      var ratio = biggest[0] / biggest[1];
      var box = this.getBoundingClientRect();
      // Densidad con tope x1,5: en video en movimiento no se aprecia mas, y es lo que separa bajarse 720p de 1080p
      // en un movil (3,8 MB frente a 5,7 MB en 16 s).
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      // object-fit: cover -> el video tiene que cubrir ancho Y alto del hueco.
      var need = Math.max(box.width, box.height * ratio) * dpr;
      for (var i = 0; i < list.length; i++) {
        if (list[i][0] >= need * 0.8) return list[i][2];
      }
      return biggest[2];
    }

    // Una version derivada (720p/480p calculada desde el nombre de la 1080p) que no existe: se prueba la siguiente
    // mas grande. La ultima de la lista es siempre la que Shopify da por Liquid, que existe seguro.
    fallback() {
      var list = this.list();
      for (var i = 0; i < list.length; i++) {
        if (list[i][2] === this.src && i + 1 < list.length) {
          this.src = list[i + 1][2];
          this.video.src = this.src;
          if (this.visible) this.play();
          return;
        }
      }
    }

    load() {
      if (this.src) return;
      // El hero ya puede venir arrancado por el script en linea de snippets/becay-loop-video.liquid: se adopta su src.
      var early = this.video.getAttribute('src');
      if (early) { this.src = early; this.upgrade(); return; }
      // Navegador sin H.264 (algun Chromium/Firefox de Linux): ni se intenta, se queda el poster. Sin esto el
      // error de formato dispararia el respaldo y se descargaria otra version para nada.
      if (!this.video.canPlayType || !this.video.canPlayType('video/mp4; codecs="avc1.42E01E"')) return;
      this.src = this.pick();
      if (!this.src) return;
      this.video.preload = 'auto';
      this.video.src = this.src;
    }

    // El arranque temprano elige version antes de que exista el CSS del hero, asi que puede quedarse corto. Con la
    // maqueta ya resuelta se recalcula y, si hace falta una version MAYOR, se cambia conservando el punto de
    // reproduccion. Nunca se baja: eso solo ahorraria bytes ya gastados a cambio de un corte.
    upgrade() {
      var list = this.list();
      var urls = list.map(function (x) { return x[2]; });
      var next = this.pick();
      var now = urls.indexOf(this.src);
      if (!next || now < 0 || urls.indexOf(next) <= now) return;
      var v = this.video;
      var t = v.currentTime || 0;
      this.src = next;
      v.src = next;
      if (t) v.addEventListener('loadedmetadata', function () { try { v.currentTime = t; } catch (e) {} }, { once: true });
      if (this.visible) this.play();
    }

    play() {
      if (!this.src || document.hidden) return;
      silence(this.video);
      var p = this.video.play();
      if (p && p.catch) p.catch(() => { blocked.add(this); armGesture(); });
    }
  }

  customElements.define('becay-loop-video', BecayLoopVideo);
})();
